exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.marker[data-v-6529d47a] {\n    padding: 6px 8px;\n    max-width: 120px;\n}\n\n", ""]);
